import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { shutdown } from '@intercom/messenger-js-sdk';
import { CircularProgress } from '@mui/material';
import queryClient from 'src/queryClient';
import * as appOperations from 'src/store/modules/app/operations';
import { authOperations } from 'src/store/modules/auth';
import { trackLogOut } from 'src/utils/mixpanel';
import { amplifySignOut } from 'src/utils/auth';
import { parseQueryString } from 'src/utils/browser';
import { saveSSOReferrer } from 'src/utils/sso';
import { clearAuthMethod } from 'src/utils/authVersion';
import { getEnterpriseSsoHost, getSsoReferrer } from 'src/utils/ssoReferrer';

const SignOut = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // After logout, send the user to enterprise-sso for re-auth.
    // A ?referrer query param overrides the host-derived one (preserves
    // SSO-flow referrers like 'gitbook' that arrive via /sign_out?referrer=...).
    const queryReferrer = parseQueryString().referrer as string | undefined;
    const referrer = queryReferrer || getSsoReferrer();
    const redirectUrl = `https://${getEnterpriseSsoHost()}/sign_in?referrer=${encodeURIComponent(referrer)}`;

    const performLogout = async () => {
      try {
        saveSSOReferrer();

        // Perform logout operations
        shutdown();
        await dispatch(authOperations.logOut());
        trackLogOut();
        localStorage.removeItem('x-sl-signin-user-email');
        clearAuthMethod();
        await amplifySignOut();
        dispatch(appOperations.fetchConfig());
        queryClient.clear();
        dispatch(appOperations.clearReduxState());
      } catch (error) {
        console.error('Error signing out:', error);
        // Fall through to the redirect even on error
      } finally {
        window.location.href = redirectUrl;
      }
    };

    performLogout();
  }, [dispatch]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        gap: '16px',
        fontSize: '18px',
        fontFamily: 'Geist, sans-serif'
      }}
    >
      <CircularProgress size={48} />
      Signing out...
    </div>
  );
};

export default SignOut;
